module.exports = __webpack_public_path__ + "static/img/yx5.7df16ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx5.jpg
// module id = Ob4y
// module chunks = 1